module.exports = __webpack_public_path__ + "img/close.17109e4b.svg";